<template>
  <div>
    <div>
      <div class="" v-if="loading">
        <!-- Show the loader when async operation is going on -->
        <div class="loader"></div>
      </div>
      <div  v-else>
        <div class="row mt-10">
          <div class="col-md-12 mb-10">
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text"><i class="fa fa-search"></i></span>
              </div>
              <input v-model="searchQuery" type="text" class="form-control" placeholder="Search">
            </div>
            <span class="text-danger font-weight-bold custom-font-size">Note: Hover over the service name to see all access. </span>
          </div>
          <div class="col-md-6 mt-10 pr-0 mb-10 text-center cursor-pointer" @click="changeTab('collaborator')">
             <span class="font-weight-bold custom-font-size"> Access Given By This Account <span class="badge badge-light text-primary">{{collaboratorGroup.length}}</span></span>
            <div class="mt-10"  :class="activeTab === 'collaborator' ?  'selected-border' : 'unselected-border' "></div>
          </div>
          <div class="col-md-6 mt-10 mb-10 pl-0 text-center cursor-pointer" @click="changeTab('supp')">
            <span class="font-weight-bold custom-font-size">Access Given To This Account  <span class="badge badge-light text-primary">{{supervisorGroup.length}}</span></span>
            <div class="mt-10" :class="activeTab === 'supp' ?  'selected-border' : 'unselected-border'"></div>
          </div>

        <div class="col-md-12" v-if="activeTab==='collaborator'">
        <perfect-scrollbar v-if='collaboratorGroup && collaboratorGroup.length' class="scroll-area">
          <ul class="list-group list-group-flush">
            <li class="list-group-item announcement-item" v-for="(row, index) in paginatedCollaborators" :key="row.id">
              <div class="d-flex align-items-center justify-content-between make-cursor-pointer">
                <div class="d-flex align-items-center pl-15">
                  <div class="pr-10">
                    <img :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.email)}?s=40`">
                  </div>
                  <div>
                    <div v-if="row.name" >
                      <span class="text-primary" >{{row.name}}</span>
                      <br>
                      <span>{{row.email}}
                        </span>
                      <span class="font-weight-bold" data-toggle="tooltip" :key="`collab-${index}`"  data-placement="top" style="cursor: pointer" :title="getDomains(row, 'collaborator')"> ({{row.domains[0]}}) </span>
                    </div>
                    <div  v-else>
                      <span class="text-primary">{{row.email}} </span>
                      <br>
                      <span class="font-weight-bold" data-toggle="tooltip" :key="`collab2-${index}`" data-placement="top" style="cursor: pointer" :title="getDomains(row , 'collaborator')">({{row.domains[0]}}) </span>
                    </div>
                  </div>
                </div>
                <div class="pr-15">
                  <button @click="goToNuxt(row.uid)" title="Login as User" type="button" rel="tooltip" class="btn btn-outline-primary btn-icon btn-sm mr-4">
                    <i class="fa fa-user"></i>
                  </button>
                </div>
              </div>
            </li>
          </ul>
        </perfect-scrollbar>
        <p v-else class="hm300 card-text text-center text-danger mb-3 font-weight-bold pt-20">No collaborators exist.</p>
        <div v-if="collaboratorGroup && collaboratorGroup.length>0" class="row pt-20">
          <div class="col-md-12 text-center">
                <span class="lh-3 pull-left">
                    Page {{this.pageNumber + 1}} of {{ this.collaboratorPageCount }}
                </span>
            <section class="dataTables_paginate paging_full_numbers">
              <paginate
                  :pageCount="this.collaboratorPageCount"
                  :clickHandler="goToPage"
                  :prevText="'Prev'"
                  :nextText="'Next'"
                  page-class="page-item"
                  prev-class="page-item"
                  prev-link-class="page-link"
                  next-class="page-item"
                  next-link-class="page-link"
                  page-link-class="page-link"
                  containerClass="pagination">
              </paginate>
            </section>
          </div>
        </div>
        </div>
          <div class="col-md-12" v-else>
            <perfect-scrollbar v-if='supervisorGroup && supervisorGroup.length' class="scroll-area">
              <ul class="list-group list-group-flush">
                <li class="list-group-item announcement-item" v-for="(row, index) in paginatedSupervisors" :key="row.id">
                  <div class="d-flex align-items-center justify-content-between make-cursor-pointer">
                    <div class="d-flex align-items-center pl-15">
                      <div class="pr-10">
                        <img :src="`https://www.gravatar.com/avatar/${emailHashGravatar(row.email)}?s=40`">
                      </div>
                      <div>
                        <div v-if="row.supervisorName" >
                          <span class="text-primary" >{{row.supervisorName}}</span>
                          <br>
                          <span>{{row.supervisorEmail}}
                        </span>
                          <span class="font-weight-bold" :key="`super-${index}`" data-toggle="tooltip" data-placement="top" style="cursor: pointer" :title="getDomains(row, 'supervisor')"> ({{row.allowedDomains[0]}}) </span>
                        </div>
                        <div  v-else>
                          <span class="text-primary">{{row.supervisorEmail}} </span>
                          <br>
                          <span class="font-weight-bold" data-toggle="tooltip"   :key="`super2-${index}`"  data-placement="top" style="cursor: pointer" :title="getDomains(row, 'supervisor')">({{row.allowedDomains[0]}})</span>
                        </div>
                      </div>
                    </div>
                    <div class="pr-15">
                      <button @click="goToNuxt(row.uid)" title="Login as User" type="button" rel="tooltip" class="btn btn-outline-primary btn-icon btn-sm mr-4">
                        <i class="fa fa-user"></i>
                      </button>
                    </div>
                  </div>
                </li>
              </ul>
            </perfect-scrollbar>
            <p v-else class="hm300 card-text text-center text-danger mb-3 font-weight-bold pt-20">No collaborators exist.</p>
            <div v-if="supervisorGroup && supervisorGroup.length>0" class="row pt-20">
              <div class="col-md-12 text-center">
                <span class="lh-3 pull-left">
                    Page {{this.pageNumber + 1}} of {{ this.supervisorPageCount }}
                </span>
                <section class="dataTables_paginate paging_full_numbers">
                  <paginate
                      :pageCount="this.supervisorPageCount"
                      :clickHandler="goToPage"
                      :prevText="'Prev'"
                      :nextText="'Next'"
                      page-class="page-item"
                      prev-class="page-item"
                      prev-link-class="page-link"
                      next-class="page-item"
                      next-link-class="page-link"
                      page-link-class="page-link"
                      containerClass="pagination">
                  </paginate>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>
<script>
import {db} from "@/firebase/init";
import {PerfectScrollbar} from 'vue2-perfect-scrollbar';
import Paginate from 'vuejs-paginate'
import md5 from "crypto-js/md5";
export default {
  name: "CollaboratorList",
  components: {
    PerfectScrollbar,
    Paginate
  },
  data () {
    return {
      announcementGroup: [],
      supervisorGroup: [],
      collaboratorGroup: [],
      loading: false,
      pageNumber: 0,
      showRecords: 10,
      searchQuery: '',
      activeTab: 'collaborator',
    }
  },
  mounted() {
    this.getCollaborators()
  },
  updated() {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
  },
  computed: {
    customerInfo () {
      return this.$store.getters["customer/details"];
    },
    paginatedCollaborators(){
      const start = this.pageNumber * this.showRecords, end = start + this.showRecords;
      return this.filteredCollaborators.slice(start, end);
    },
    paginatedSupervisors(){
      const start = this.pageNumber * this.showRecords, end = start + this.showRecords;
      return this.filterSupervisors.slice(start, end);
    },
    filteredCollaborators() {
      return this.collaboratorGroup.filter((collaborator) => {
        return collaborator.name.toLowerCase().includes(this.searchQuery.toLowerCase()) || collaborator.email.toLowerCase().includes(this.searchQuery.toLowerCase()) || this.checkDomain(collaborator.domains);
      });
    },
    filterSupervisors(){
      const array = this.supervisorGroup.filter((supervisor) => {
        return supervisor.supervisorName.toLowerCase().includes(this.searchQuery.toLowerCase()) || supervisor.supervisorEmail.toLowerCase().includes(this.searchQuery.toLowerCase()) || this.checkDomain(supervisor.allowedDomains);
      });
      return array.sort(function(a, b) { return b.status.localeCompare(a.status) });
    },
    collaboratorPageCount () {
      let l = parseInt(this.collaboratorGroup.length), s = parseInt(this.showRecords);
      return Math.ceil(l/s);
    },
    supervisorPageCount () {
      let l = parseInt(this.supervisorGroup.length), s = parseInt(this.showRecords);
      return Math.ceil(l/s);
    },
  },
  methods: {
    changeTab(value){
    this.activeTab=value;
    this.pageNumber=0;
    },
    checkDomain (domains) {
      let search = false;
      domains.map((el) => {
        if (el.includes(this.searchQuery.toLowerCase())) {
          search = true;
        }
      });
      return search;
    },
    async goToNuxt (docId) {
      window.open(`https://wpo.bigscoots.com/user/dashboard?id=${docId}`,'WPO-Bigscoots');
    },
    goToPage (pageNum) {
      this.pageNumber = pageNum - 1;
    },
    getDomains (supervisor, type) {
      let accessLevels = supervisor.accessLevels ? JSON.parse(JSON.stringify(supervisor.accessLevels)) : ['full'];
      let allowedDomains=[]
      if(type==='collaborator'){
         allowedDomains = supervisor.domains ? JSON.parse(JSON.stringify(supervisor.domains)) : [];
      }
      else{
         allowedDomains = supervisor.allowedDomains ? JSON.parse(JSON.stringify(supervisor.allowedDomains)) : [];
      }
      accessLevels = accessLevels.map(allow => allow.charAt(0).toUpperCase() + allow.slice(1))


      const total = allowedDomains.length - 3
      // allowedDomains = allowedDomains.splice(0, 3)
      // total > 1 ? `${allowedDomains.join(',')}, ${total} more domains` :
      const domainAccess = supervisor.allowAll ? 'All domains' :  allowedDomains.join(', ')

      if(supervisor.futureAccess){
        return  `Access (${accessLevels.join(', ')}) | Access to future domains | ${domainAccess}`
      }
      return`Access (${accessLevels.join(', ')}) | ${domainAccess}`

    },
    emailHashGravatar(email) {
      if (!email) {
        return null
      } else {
        return md5(email.trim().toLowerCase()).toString()
      }
    },
    async getCollaborators() {
      try {
        this.loading = true;
        this.collaboratorGroup = []
        const refData= await db.collection('users').doc(this.customerInfo.docID).get();
        this.collaboratorGroup= refData.data().collaborators || []
        this.supervisorGroup= refData.data().supervisors || []
        console.log('refCol', this.collaboratorGroup)
      } catch (e) {
        console.log('error from collaborators', e.toString())
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>
<style scoped lang="scss">
img{
  border-radius: 50%;
}
.list-group-item{
  &.announcement-item{
    padding: 18px 0px;
    &:hover {
      background-color: #f5f5f5;
      color: #333;
      box-shadow: 0px 5px 5px 1px rgba(0, 0, 0, 0.2) !important;
    }
  }
}
.scroll-area {
  position: relative;
  max-height: 500px;
  /*overflow: hidden;*/
}
.text-closed{
  font-weight: 400 !important;
}
.text-open{
  font-weight: 700 !important;
}
.tooltip-inner {
  background-color: #f00 !important;
  color: #f00 ;
}
.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^="top"] .arrow::before {
  border-top-color: #f00 !important;
}

.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^="right"] .arrow::before {
  border-right-color: #f00 !important;
}


.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^="bottom"] .arrow::before {
  border-bottom-color: #f00 !important;
}

.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^="left"] .arrow::before {
  border-left-color: #f00 !important;
}
.form-control .input-group-text {
  background-color: #e9ecef !important;; /* Default background color */
  border: 1px solid grey !important;
}

.input-group>.form-control{
  position: relative;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  width: 1%;
  margin-bottom: 0;
  border: 1px solid #E3E3E3;
  border-left: 0 none;
  color: black
}
.unselected-border{
  border-bottom: 2px solid lightgray;
}
.selected-border{
  border-bottom: 2px solid #5A7CFD;
}
.custom-font-size {
  font-size: 0.75rem; /* 12px */
}
.cursor-pointer{
  cursor: pointer;
}
.badge{
  padding: 1px 8px !important;
}
</style>
